import { useState } from "react";
import { MapPin, Search } from "lucide-react";
import { filterEntries } from "../../lib/serviceAreas";
import { inputCls, StepError } from "./WizardBits";

const Chip = ({ label, selected, onClick, extended }) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    data-testid={`wizard-city-${label}`}
    onClick={onClick}
    className={`inline-flex items-center gap-2 px-3.5 py-2 border text-[14px] transition-colors duration-200 focus:outline-none focus-visible:ring-1 focus-visible:ring-gold ${
      selected ? "border-gold bg-gold/10 text-white" : "border-white/10 text-zinc-300 hover:border-white/30 hover:text-white"
    }`}
  >
    <span className={`w-1.5 h-1.5 rounded-full ${extended ? "border border-gold/70" : "bg-gold"}`} /> {label}
  </button>
);

export const StepLocation = ({ c, w }) => {
  const L = c.location;
  const [q, setQ] = useState("");
  const list = filterEntries(q);
  const groups = [["core", L.core], ["extended", L.extended]];
  const isOther = w.data.city === "__other";
  return (
    <div>
      <div className="relative">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" aria-hidden />
        <input data-testid="wizard-city-search" aria-label={L.search} value={q} onChange={(e) => setQ(e.target.value)} placeholder={L.search} className={`${inputCls} pl-11`} />
      </div>
      <div role="radiogroup" aria-label={c.stepTitles[1]} className="mt-5 max-h-[300px] overflow-y-auto pr-1 space-y-5">
        {groups.map(([key, label]) => {
          const items = list.filter((e) => e.area === key);
          if (!items.length) return null;
          return (
            <div key={key}>
              <div className="mb-3 text-[11px] tracking-[0.25em] uppercase text-zinc-500">{label}</div>
              <div className="flex flex-wrap gap-2">
                {items.map((e) => (
                  <Chip key={e.label} label={e.label} extended={key === "extended"} selected={w.data.city === e.label} onClick={() => w.set("city", e.label)} />
                ))}
              </div>
              {key === "extended" && <p className="mt-3 text-[13px] text-zinc-500">{L.extendedNote}</p>}
            </div>
          );
        })}
        {!list.length && <p data-testid="wizard-city-none" className="text-[14px] text-zinc-400">{L.noResults}</p>}
      </div>
      <div className="mt-6 pt-5 border-t border-white/10">
        <button type="button" role="radio" aria-checked={isOther} data-testid="wizard-city-other" onClick={() => w.set("city", "__other")}
          className={`inline-flex items-center gap-2 text-[14px] transition-colors ${isOther ? "text-gold" : "text-zinc-300 hover:text-white"}`}>
          <MapPin size={15} /> {L.other}
        </button>
        {isOther && (
          <input data-testid="wizard-city-custom" autoFocus aria-label={L.other} value={w.data.cityCustom} onChange={(e) => w.set("cityCustom", e.target.value)} placeholder={L.otherPlaceholder} className={`${inputCls} mt-3`} />
        )}
      </div>
      <StepError text={w.errors.location} testid="wizard-error-location" />
    </div>
  );
};
